import { defineMessages } from 'react-intl';

export const objectListMessages = defineMessages({
  internalErrors: {
    id: 'There are errors in one or more items in the list',
    defaultMessage: 'There are errors in one or more items in the list',
  },
});
